// components
import { Suspense } from "react";

const SuspensedView = ({ children }) => {
  return <Suspense fallback={<p>Loading...</p>}>{children}</Suspense>;
};

export default SuspensedView;
